const moment = require('moment')
// const s = require('@/security.js')
export const socketOutputMixin = {

  methods: {
    enc (data) {
      let key = '0a34e8b3-d947-4379-a289-de33e8e2ac94'
      let iv = key.split('').reverse().join('')
      return this.ewk(data, key, iv)
    },
    socketRequestUpdatedData () {
      var requestTasks = {}
      requestTasks.Type = 'get'
      requestTasks.Task = 'updated_data'
      requestTasks.Version = ''
      requestTasks.DeviceType = '3'
      requestTasks.From = this.$store.state.session.user.UserID
      requestTasks.UpdateDate =  '2010-12-01 12:12:12.122'
      requestTasks.hashValue = ''

      this.$store.state.socket.connection.send(this.enc(JSON.stringify(requestTasks)))
    },

    setStartTyping () {
      if (this.activeConversation && this.activeConversation.isChannelConversation) {
        return
      }

      var msg = {
        Type: 'set',
        Task: 'start_typing',
        From: this.$store.state.session.user.UserID,
        To: this.activeConversation.ContactID
      }
      this.$store.state.socket.connection.send(this.enc(JSON.stringify(msg)))
    },

    setPinConversation () {
      var msg = {
        Type: 'set',
        Task: 'update_settings',
        From: this.$store.state.session.user.UserID,
        UserSettings: JSON.stringify(this.$store.state.conversation.userSettings)
      }
      this.$store.state.socket.connection.send(this.enc(JSON.stringify(msg)))
    },

    setStopTyping () {
      if (this.activeConversation && this.activeConversation.isChannelConversation) {
        return
      }

      var msg = {
        Type: 'set',
        Task: 'stop_typing',
        From: this.$store.state.session.user.UserID,
        To: this.activeConversation.ContactID
      }
      this.$store.state.socket.connection.send(this.enc(JSON.stringify(msg)))
    },

    sendLeaveGroupMessage (group) {
      var msg = {}
      msg.Type = 'set'
      msg.Task = 'group_remove_participant'
      msg.From = this.$store.state.session.user.UserID
      msg.GroupID = group.GroupID
      msg.Participants = [this.$store.state.session.user.UserID]

      if (group.Deleteds) {
        group.Deleteds.push(this.$store.state.session.user.UserID)
      } else {
        group.Deleteds = [this.$store.state.session.user.UserID]
      }

      this.$store.state.socket.connection.send(this.enc(JSON.stringify(msg)))
    },

    sendParticipantRemoveGroupMessage (participant, group) {
      var msg = {}
      msg.Type = 'set'
      msg.Task = 'group_remove_participant'
      msg.From = this.$store.state.session.user.UserID
      msg.GroupID = group.GroupID
      msg.Participants = [participant]

      if (group.Deleteds) {
        group.Deleteds.push(participant)
      } else {
        group.Deleteds = [participant]
      }

      this.$store.state.socket.connection.send(this.enc(JSON.stringify(msg)))
    },

    sendMakeAdminMessage (participant, group) {
      var msg = {}
      msg.Type = 'set'
      msg.Task = 'group_make_admin'
      msg.From = this.$store.state.session.user.UserID
      msg.GroupID = group.GroupID
      msg.UserID = participant

      this.$store.state.socket.connection.send(this.enc(JSON.stringify(msg)))
    },

    sendRemoveAdminMessage (participant, group) {
      var msg = {}
      msg.Type = 'set'
      msg.Task = 'group_remove_admin'
      msg.From = this.$store.state.session.user.UserID
      msg.GroupID = group.GroupID
      msg.UserID = participant

      this.$store.state.socket.connection.send(this.enc(JSON.stringify(msg)))
    },

    sendAddToGroupMessage (groupId, participants) {
      var msg = {}
      msg.Type = 'set'
      msg.Task = 'group_add_participant'
      msg.From = this.$store.state.session.user.UserID
      msg.GroupID = groupId
      msg.Participants = participants

      this.$store.state.socket.connection.send(this.enc(JSON.stringify(msg)))
    },

    forwardThisMessage (message) {
      var newMsg = JSON.parse(JSON.stringify(message))
      newMsg.MessageID = this.$uuid.v4()
      newMsg.CreateDate = moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z' // MMMM Do YYYY, h:mm:ss
      newMsg.UpdateDate = moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z' // MMMM Do YYYY, h:mm:ss
      newMsg.From = this.$store.state.session.user.UserID
      if (this.$store.state.conversation.activeConversation.isGroupConversation === true) {
        newMsg.To = this.$store.state.conversation.activeConversation.GroupID
        newMsg.ConversationID = ''
        newMsg.isGroup = true
        newMsg.ConversationType = 1
      } else if (this.$store.state.conversation.activeConversation.isChannelConversation === true) {
        newMsg.To = this.$store.state.conversation.activeConversation.ChannelID
        newMsg.ConversationID = ''
        newMsg.isGroup = false
        newMsg.ConversationType = 2
      } else {
        newMsg.To = this.$store.state.conversation.activeConversation.ContactID
        newMsg.ConversationID = this.$store.state.conversation.activeConversation.ConversationID
        newMsg.ConversationType = 0
      }

      this.$store.dispatch('appendMessages', [newMsg])
      this.$store.dispatch('clearActiveNewMessage')

      this.$store.state.socket.connection.send(this.enc(JSON.stringify(newMsg)))

      if (this.$store.state.socket.connection.readyState === 1) {
        newMsg.Status = 1
      }
    },

    updateGroup (data) {
      let editGrp = {}
      editGrp.Type = 'set'
      editGrp.Task = 'update_group'
      editGrp.From = this.$store.state.session.user.UserID

      editGrp.GroupID = data.GroupID
      editGrp.GroupName = data.GroupName
      editGrp.GroupDescription = data.GroupDescription
      editGrp.PhotoURL = data.PhotoURL
      editGrp.MessageAuth = data.MessageAuth

      this.$store.state.socket.connection.send(this.enc(JSON.stringify(editGrp)))
    },

    updateProfile (data) {
      let updateMessage = {}
      updateMessage.Type = 'set'
      updateMessage.Task = 'update_profile'
      updateMessage.From = this.$store.state.session.user.UserID
      updateMessage.VisibleName = data.VisibleName
      updateMessage.PhotoURL = data.PhotoURL
      updateMessage.StatusText = data.StatusText

      this.$store.state.socket.connection.send(this.enc(JSON.stringify(updateMessage)))
    },

    get_settings (data) {
      let updateMessage = {}
      updateMessage.Type = 'get'
      updateMessage.Task = 'get_settings'
      updateMessage.From = this.$store.state.session.user.UserID
      updateMessage.UpdateDate = '-1'

      this.$store.state.socket.connection.send(this.enc(JSON.stringify(updateMessage)))
    },
    get_stars (data) {
      let updateMessage = {}
      updateMessage.Type = 'get'
      updateMessage.Task = 'get_stars'
      updateMessage.From = this.$store.state.session.user.UserID
      updateMessage.UpdateDate = '-1'

      this.$store.state.socket.connection.send(this.enc(JSON.stringify(updateMessage)))
    }
  }
}
